import React from 'react'
import { connect } from 'react-redux'

import { MsgToUserActionCreators } from '../redux/reducers/msgToUser/action-creators'

import { Loader } from '../components'

import 'react-toastify/dist/ReactToastify.css'
import { Languages } from '../redux/reducers/language/languageData'
import withRouter from '../HOC/widthRouter'
import { GuestActionCreators } from '../redux/reducers/guest/action-creators'

class ConfirmationPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const {
      location: { state: locationState },
      navigate,
    } = this.props

    const { language: selectedLanguage } = this.props.language
    const language = Languages(selectedLanguage)

    return (
      <>
        <div className={'confirmation_result confirmation_result--success'}>
          <div className='container container--confirmation'>
            <div className='confirmation_result-desc'>
              {language.confirmationInfo}
            </div>
          </div>
        </div>
        <div className='confirmation container container--confirmation'>
          <div className='confirmation_data-items'>
            <div className='confirmation_data-item'>
              <div className='confirmation_data-item-title confirmation-data-content'>
                {language?.paymentWith}
              </div>
              <div className='confirmation_data-item-body confirmation-data-content'>
                {locationState?.payWith}{' '}
              </div>
            </div>
            <div className='confirmation_data-item'>
              <div className='confirmation_data-item-title confirmation-data-content'>
                {language?.maskedPan}
              </div>
              <div className='confirmation_data-item-body confirmation-data-content'>
                {locationState?.paymentRequest?.paymentMethodData?.description}
              </div>
            </div>
            <div className='confirmation_data-item'>
              <div className='confirmation_data-item-title confirmation-data-content'>
                {language?.serviceName}
              </div>
              <div className='confirmation_data-item-body confirmation-data-content'>
                {locationState?.serviceName}
              </div>
            </div>
            <div className='confirmation_data-item'>
              <div className='confirmation_data-item-title confirmation-data-content'>
                {language.amount}
              </div>
              <div className='confirmation_data-item-body confirmation-data-content'>
                {locationState?.mainState.amountValue}{' '}
                {locationState?.mainState.debtCurrency || 'AZN'}
              </div>
            </div>
          </div>
          <button
            className='confirmation_btn'
            onClick={async () => {
              let loading = false
              try {
                this.setState({ isLoading: true })

                const tokenType =
                  locationState?.payWith === 'Google Pay' ? 3 : 2

                await this.props.doGuestPay(
                  locationState?.serviceId,
                  locationState?.mainState.amountValue,
                  JSON.stringify({
                    fields: locationState?.mainState?.fields,
                  }),
                  false,
                  locationState?.mainState?.subName,
                  locationState?.mainState?.subVal,
                  locationState?.mainState?.groupId || 0,
                  '',
                  locationState.paymentRequest?.paymentMethodData
                    ?.tokenizationData?.token,
                  tokenType,
                )

                navigate(
                  `/frames/${selectedLanguage}/check?orderId=${this.props.guestPayment.orderId}&tokenType=${tokenType}`,
                )
              } catch (e) {
                this.setState({ isLoading: false })
                loading = false
              } finally {
                if (!loading) {
                  this.setState({ isLoading: false })
                } else {
                  this.setState({ isLoading: true })
                }
              }
            }}
          >
            {language?.confirm}
          </button>

          {this.state.isLoading && (
            <div className='loader-wrapper loader-wrapper--check'>
              <Loader />
            </div>
          )}
        </div>
      </>
    )
  }
}

const mapStateToProps = state => ({
  settings: state.settings,
  guestPayment: state.guestPayment,
  language: state.language,
})
const mapDispatchToProps = {
  MsgToUserState: MsgToUserActionCreators.msgToUserState,
  doGuestPay: GuestActionCreators.doGuestPay,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(ConfirmationPage))
